import * as React from "react";
import { IconButton, Snackbar } from "@mui/material";
import { Alert } from "@mui/material";
// import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { closeNotification } from "../../redux/slices/notificationSlice";

const iconStyle = {
  transform: "rotate(0deg)",
  opacity: 1,
};

const CustomSnack = () => {
  const dispatch = useDispatch();
  // const theme = useTheme();

  const state = useSelector(
    ({ notification: { message, open, severity } }) => ({
      message,
      open,
      severity,
    })
  );

  const handleClose = () => dispatch(closeNotification());

  if (!state.open || !["success", "newSuccess", "error"].includes(state.severity)) return null;

  const isSuccess = ["success", "newSuccess"].includes(state.severity);
  const bgColor = isSuccess ? "#20842F" : "#851109";
  const borderColor = isSuccess ? "#224D22" : "#380704";
  const alertIconSrc = isSuccess ? "/images/success-alert.svg" : "/images/failure-alert.svg";
  const icon = isSuccess ? (
    <img src={alertIconSrc} alt="success" width={20} height={20} style={iconStyle} />
  ) : (
    <img src={alertIconSrc} alt="error" width={20} height={20} style={iconStyle} />
  );

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={4000}
      sx={{
        zIndex: 1444444,
        minWidth: 280,
        maxWidth: 580,
        width: {
          xs: "calc(100% - 32px)",
          sm: 562,
        },
      }}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={handleClose}
    >
      <Alert
        icon={icon}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
            sx={{ p: 0, width: 16, height: 16 }}
          >
            <img src="/images/close.svg" alt="close" width={16} height={16} style={iconStyle} />
          </IconButton>
        }
        onClose={handleClose}
        sx={{
          bgcolor: bgColor,
          border: `0.5px solid ${borderColor}`,
          borderRadius: "16px",
          color: "#FFFFFF",
          p: "16px",
          // minHeight: "56px",
          width: {
            xs: "calc(100% - 32px)",
            sm: 562,
          },
          minWidth: 280,
          maxWidth: 580,
          margin: "0 auto",
          fontWeight: 700,
          fontSize: "12px",
          lineHeight: "16px",
          fontFamily: "Open Sans",
          boxShadow: "none",
          alignItems: "center",
          "& .MuiAlert-icon": {
            p: 0,
            mr: 1,
            alignItems: "center",
            opacity: 1,
          },
          "& .MuiAlert-icon img": {
            display: "block",
            opacity: 1,
          },
          "& .MuiAlert-message": {
            p: 0,
            flex: 1,
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
          },
          "& .MuiAlert-action": {
            p: 0,
            m: 0,
            pl: 1,
            alignItems: "center",
          },
          "& .MuiAlert-action img": {
            display: "block",
            opacity: 1,
          },
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {state.message}
        </span>
      </Alert>
    </Snackbar>
  );
};

export default CustomSnack;